import { Button, Stack } from '@mui/material'
import { GridColumnVisibilityModel } from '@mui/x-data-grid-premium'
import CustomFiltersModal from 'components/DataGrid/components/CustomFiltersModal'
// import { projectManagerViewState, seoViewState } from 'components/DataGrid/createColumns/gridViewStates'
import VisibilityIcon from '@mui/icons-material/Visibility'
import CustomViewsMenu from 'components/ui/custom-views-menu'
import { Dispatch, SetStateAction } from 'react'
import { projectManagerViewState, seoViewState } from './defaultModels'

const NcoCustomViews = ({
  currentView,
  setCurrentView,
  onChangeVisibility,
  isOpen,
  anchorEl,
  onOpenViews,
  onClose,
}: {
  onChangeVisibility: (newVisibilityState: GridColumnVisibilityModel) => void
  isOpen: boolean
  anchorEl: HTMLElement | null
  onOpenViews: (event: React.MouseEvent) => void
  onClose: () => void
  currentView: string
  setCurrentView: Dispatch<SetStateAction<string>>
}) => {
  return (
    <>
      <CustomViewsMenu
        onOpenCustomViews={onOpenViews}
        icon={<VisibilityIcon sx={{ fontSize: '30px', color: isOpen ? 'text.highlight' : 'text.primary' }} />}
        currentView={currentView}
        badgeColor={'icon.nco'}
      />
      <CustomFiltersModal isOpen={isOpen} anchorEl={anchorEl} handleCloseCustomFilters={onClose}>
        <Stack gap={1}>
          <Button
            onClick={() => {
              onChangeVisibility(projectManagerViewState)
              setCurrentView('PM')
            }}
            variant="outlined"
          >
            PM VIEW
          </Button>
          <Button
            onClick={() => {
              onChangeVisibility(seoViewState)
              setCurrentView('SEO')
            }}
            variant="outlined"
          >
            SEO VIEW
          </Button>
        </Stack>
      </CustomFiltersModal>
    </>
  )
}
export default NcoCustomViews
